import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("td", {
    class: _normalizeClass([_ctx.dynamicClasses, "px-6 py-4 text-md text-gray-700 md:whitespace-nowrap"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}